'use strict';

var d3 = require('d3');
var _ = require('lodash');
var angular = require('angular');
var AbstractProfileChart = function AbstractProfileChart(AbstractChart, chartXAxis, chartYAxis, chartConstants, chartCurves, chartHoverOver, chartSquareIndicators, userPreferencesService) {
  var Chart = function Chart(container, formatters) {
    var self = this;
    this.tooltipClassName = formatters.tooltipFormatter.cssClass || 'fa-profile-chart';
    AbstractChart.call(this, container);
    this.axisDirection = userPreferencesService.getUserDateTimeSettings('defaultRTPView');
    this.axisMode = _.isEqual(this.axisDirection, chartConstants.DIRECTION.RTL) ? chartConstants.AXIS.MODE.RIGHT : chartConstants.AXIS.MODE.LEFT;
    this.xAxis = chartXAxis(formatters.xAxisTickFormatter).label('Days to Departure');
    this.yAxis = chartYAxis(formatters.yAxisTickFormatter, this.axisMode).withLabelRotation(_.isEqual(this.axisMode, chartConstants.AXIS.MODE.RIGHT) ? -90 : 0);
    this.curves = chartCurves('dtd', 'value', 'curveData');
    this.squareIndicators = chartSquareIndicators('dtd', 'value', 'curveData', 'lca', ['yPropertyValue', 'xPropertyValue', 'className'], ['desc', 'asc', 'asc']);
    this.hoverOver = chartHoverOver('curveData', 'dtd', 'value', formatters.tooltipFormatter, undefined, this.tooltipClassName, 'top');
    this.withMetric = function (metric) {
      this.yAxis.label(metric);
      return this;
    };

    /**
     * Stops propagation of mouse events so it would not mess with carousel
     */
    function bindEvents() {
      var stopPropagation = function stopPropagation() {
        d3.event.stopPropagation();
      };
      self.svg.on('mouseover', stopPropagation);
      self.svg.on('mouseout', stopPropagation);
      self.svg.on('mousedown', stopPropagation);
      self.svg.on('click', stopPropagation);
    }
    bindEvents();
    container.on('$destroy', function () {
      self.svg.on('mouseover', null);
      self.svg.on('mouseout', null);
      self.svg.on('mousedown', null);
      self.svg.on('click', null);
      angular.element(document.getElementsByClassName('d3-tip ' + self.tooltipClassName)).remove();
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
AbstractProfileChart.$inject = ['AbstractChart', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'ChartElementsCurves', 'ChartElementsHoverOver', 'ChartElementsSquareIndicators', 'UserPreferencesService'];
module.exports = AbstractProfileChart;